var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCallCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 13.5866C20 13.977 19.6836 14.2956 19.2966 14.2956H17.3252V7.56414L17.3177 7.52909C16.5522 4.0779 13.5118 1.62416 10.0003 1.62416C6.48877 1.62416 3.44887 4.0779 2.6818 7.52909L2.6743 7.56414V14.2956H0.703369C0.316891 14.2956 0 13.977 0 13.5866V8.34647C0 7.95719 0.316891 7.63747 0.703369 7.63747H1.5063L1.60212 7.20613C2.51693 3.07667 5.79986 0.5 10.0003 0.5C14.2001 0.5 17.4825 3.07667 18.3984 7.20613L18.4937 7.63747H19.2966C19.6836 7.63747 20 7.95719 20 8.34647V13.5866ZM15.9645 14.3107C15.503 15.5174 14.8189 16.635 13.9277 17.5673C12.8571 18.6877 11.544 19.25 10.0003 19.25C7.94262 19.25 6.74571 18.3043 5.6746 17.1828C5.64516 17.1526 5.61625 17.1181 5.58788 17.0869C6.39563 17.288 7.42713 17.46 8.26807 17.5063C8.36549 17.7959 8.62779 18.004 8.93451 18.004H10.4467C10.8369 18.004 11.1549 17.6681 11.1549 17.2556V17.0594C11.1549 16.6474 10.8369 16.3116 10.4467 16.3116H8.93451C8.66633 16.3116 8.43187 16.4706 8.31197 16.7041C7.26548 16.6464 6.23397 16.4582 5.23834 16.1433C5.12967 16.1094 5.02208 16.0722 4.91395 16.035C4.47716 15.3934 4.31389 15.038 4.03554 14.3107V7.86607C4.68538 5.0829 7.15307 3.1101 10.0003 3.1101C12.8464 3.1101 15.3146 5.0829 15.9645 7.86607V14.3107Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCallCenter);
export default __webpack_public_path__ + "static/media/icon-call-center.ec2ad57a13fa922574960ee9eb6c410e.svg";
export { ForwardRef as ReactComponent };